import { IPrAttendanceEntity } from "@odata/GeneratedEntityTypes";
import React from "react";

import NumberType from "../../../types/Number";
import { FormStorage } from "../../../views/formView/FormStorage";
import {
    BalancingPeriodSummaryHeader,
    BalancingPeriodSummaryLabel,
    BalancingPeriodSummaryRows,
    BalancingPeriodSummarySubheader,
    BalancingPeriodSummaryValue,
    BalancingPeriodSummaryWrapper
} from "./Attendance.styles";
import { getAttendanceBalancingPeriodSummary } from "./Attendance.utils";
import { IAttendanceCustomData } from "./AttendanceFormView";

interface IProps {
    storage: FormStorage<IPrAttendanceEntity, IAttendanceCustomData>;
}

function formatHours(value: number, storage: FormStorage<IPrAttendanceEntity, IAttendanceCustomData>): string {
    return `${NumberType.format(value, { maximumFractionDigits: 1, minimumFractionDigits: 0 })} ${storage.t("Components:Calendar.HourPlaceholder")}`;
}

export default function AttendanceBalancingPeriodSummary({ storage }: IProps): React.ReactElement | null {
    const summary = getAttendanceBalancingPeriodSummary(storage);

    if (!summary) {
        return null;
    }

    return (
        <BalancingPeriodSummaryWrapper>
            <BalancingPeriodSummaryHeader>
                {storage.t("Attendance:Form.BalancingPeriod")}
            </BalancingPeriodSummaryHeader>
            <BalancingPeriodSummaryRows>
                <BalancingPeriodSummarySubheader>
                    {storage.t("Attendance:Form.BalancingPeriodWeeklyAverages")}
                </BalancingPeriodSummarySubheader>
                <BalancingPeriodSummaryLabel>
                    {storage.t("Attendance:Form.BalancingPeriodAverageWorked")}
                </BalancingPeriodSummaryLabel>
                <BalancingPeriodSummaryValue>
                    {formatHours(summary.averageWorkedHours, storage)}
                </BalancingPeriodSummaryValue>
                <BalancingPeriodSummaryLabel>
                    {storage.t("Attendance:Form.BalancingPeriodAveragePlanned")}
                </BalancingPeriodSummaryLabel>
                <BalancingPeriodSummaryValue>
                    {formatHours(summary.averagePlannedHours, storage)}
                </BalancingPeriodSummaryValue>
            </BalancingPeriodSummaryRows>
        </BalancingPeriodSummaryWrapper>
    );
}
